import {
  checkImageFormat,
  checkVideoFormat,
  isImage,
  isVideo
} from "@/utils/fileFormat";
import * as yup from "yup";

import {
  MAXIMUM_IMAGE_SIZE,
  MAXIMUM_VIDEO_DURATION,
  MAXIMUM_VIDEO_SIZE,
  MAX_DESCRIPTION_CHARACTERS
} from "@/features/post/domain/constants";

export const uploadPost = yup.object({
  media: yup
    .mixed()
    .test("fileFormat", "mandatory_field_is_empty_error", (value) => {
      return value;
    }),
  caption: yup
    .string()
    .max(MAX_DESCRIPTION_CHARACTERS, "post_caption_input_limit_error"),
  isPrivate: yup.boolean().required(),
  isScheduled: yup.boolean().required(),
  scheduledAt: yup.date().when("date", {
    is: (value: Date) => value && value.getDate() === new Date().getDate(),
    then: yup.number().min(new Date().getHours(), "content_upload_error_date")
  }),
  playlists: yup.array().of(yup.string())
});

export const fileValidation = yup
  .mixed()
  .required()
  .test("imageSize", "post_image_file_size_error", (value) => {
    return isImage(value) ? value.size <= MAXIMUM_IMAGE_SIZE : true;
  })
  .test("videoSize", "post_video_file_size_error", (value) => {
    return isVideo(value) ? value.size <= MAXIMUM_VIDEO_SIZE : true;
  })
  .test("imageFormat", "post_invalid_image_format_error", (value) => {
    return isImage(value) ? checkImageFormat(value) : true;
  })
  .test("fileVideoFormat", "post_invalid_video_format_error", (value) => {
    return isVideo(value) ? checkVideoFormat(value) : true;
  })
  .test("fileFormat", "post_invalid_format_error", (value) => {
    return isImage(value) || isVideo(value);
  })
  .required();

export const videoDurationValidation = yup
  .number()
  .max(MAXIMUM_VIDEO_DURATION, "post_video_duration_error");

export type FileValidation = yup.InferType<typeof fileValidation>;
